import React from 'react';
import Text from '../../components/Text';
import { IMPACT_URL } from '../../utility/constants';
import { getLocalCurrentAndRecurringMonthlyDeadline } from '../../utility/dateHelper';

import './ImpactBannerCTA.scss';

const className = 'c-ImpactBannerCTA';

const PRE_DEADLINE_DAY = 8;
const DEADLINE_DAY = 11;

const DEADLINE_DAY_TEXT = [
  { text: 'Today, you buy one, we give one. ' },
  { text: 'Find out more!', isBolder: true },
];

const PRE_DEADLINE_DAY_TEXT = [
  { text: 'On the 11th, you buy one, we give one. ' },
  { text: 'Find out more!', isBolder: true },
];

const getText = () => {
  const {
    isDeadlineDay,
    localDay,
  } = getLocalCurrentAndRecurringMonthlyDeadline(DEADLINE_DAY);

  let text = [];
  const currentLocalDay = parseInt(localDay);
  const isPreDeadlineWindow =
    currentLocalDay >= PRE_DEADLINE_DAY && currentLocalDay < DEADLINE_DAY;

  if (isDeadlineDay) {
    text = DEADLINE_DAY_TEXT;
  } else if (isPreDeadlineWindow) {
    text = PRE_DEADLINE_DAY_TEXT;
  }

  return text;
};

const ImpactBannerCTA = () => {
  const onClick = () => {
    window.location.replace(IMPACT_URL);
  };

  const text = getText();

  if (text.length < 1) return null;

  return (
    <div className={className} onClick={onClick}>
      <Text text={text} />
    </div>
  );
};

export default ImpactBannerCTA;
